export default {
    followUs: 'Seguinos en las redes',
    buy: 'Comprá en efectivo',
    personalPurchaseLink: 'centros-de-atencion'
}